import BaseListPresenter from "../../base/BaseListPresenter";
import generateRandomCode from "../../generateCode";
import purchasesFormatReport from "./utils/purchasesFormatReport";
import salesFormatReport from "./utils/salesFormatReport";
import {
  buidlTitles,
  buildDateQuery,
  convertArrayForSheet1,
  filterWithVatable,
  getTaxableDate,
} from "./utils/utils";

class ReportsListPagePresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    deleteObjectUseCase,
    upsertUseCase,
    getCurrentUserUseCase,
    exportXLSXUseCase,
    exportPurchaseReportUseCase,
    exportSalesReportUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      deleteObjectUseCase,
      exportXLSXUseCase,
      exportPurchaseReportUseCase,
      exportSalesReportUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.getCurrentUserUseCase = getCurrentUserUseCase;
    this.exportXLSXUseCase = exportXLSXUseCase;
    this.exportPurchaseReportUseCase = exportPurchaseReportUseCase;
    this.exportSalesReportUseCase = exportSalesReportUseCase;
  }

  async componentDidMount() {
    const selectedClient = this.view.getSelectedClient();

    if (!selectedClient) {
      await this.getClient();
    }

    this.init();
    this.createQuery();
    await this.getObjects();
  }

  init() {
    const user = this.view.getCurrentUser();
    const selectedClient = this.view.getSelectedClient();

    const { collection } = this.view.state;
    const dateFilter = this.queryDate();
    const gte = dateFilter.date.gte;
    const lte = dateFilter.date.lte;

    this.where = {
      date: {
        $gte: gte,
        $lte: lte,
      },
      status: "audited",
      ...(collection === "purchases"
        ? { client: { id: selectedClient?.id || user?.client?.id } }
        : selectedClient?.user?.id && {
            creator: { id: selectedClient?.user?.id },
          }),

      ...(collection === "purchases"
        ? {
            supplier: { isVatable: true },
          }
        : { isVatable: true }),
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined;
    this.sort = { created: 1 };
    this.progress = true;
    this.reset();
  }

  queryDate() {
    const { category, year, years, month, quarter, half } = this.view.state;

    const dateFilter = buildDateQuery({
      type: category,
      years: years,
      year: year,
      month: month,
      quarter: quarter,
      half: half,
    });

    return dateFilter;
  }

  async accountantReport(collection, objects) {
    const { category, year, years, month, quarter, half, selectedClient } =
      this.view.state;

    const titles = buidlTitles({
      type: category,
      years: years,
      year: year,
      month: month,
      quarter: quarter,
      half: half,
      collectionName: collection,
      client: selectedClient,
    });

    const taxableDate = getTaxableDate({
      type: category,
      year: Number(year),
      month,
      quarter,
      half,
    });

    let formattedObjects = [];
    switch (collection) {
      case "purchases":
        formattedObjects = await purchasesFormatReport(objects, taxableDate);

        await this.exportPurchaseReportUseCase.execute(
          selectedClient,
          formattedObjects,
          titles.filename,
        );
        break;
      case "sales":
        formattedObjects = await salesFormatReport(objects, taxableDate);

        await this.exportSalesReportUseCase.execute(
          selectedClient,
          formattedObjects,
          titles.filename,
        );
        break;
      default:
        break;
    }
  }

  async onChangeClient() {
    this.init();
    this.createQuery();
    await this.findObjects();
  }

  async getClient() {
    const collection = "clients";
    const user = this.view.getCurrentUser();
    const storageKey = this.view.getStorageKey();

    const query = {
      where: {
        $and: [
          { creator: { id: user?.id } },
          { clientOf: "admin" },
          { isActive: true },
        ],
      },
      keys: ["id", "name", "billingCity", "user"],
      limit: 1,
    };

    try {
      this.view.showClientProgress();
      const clients = await this.findObjectUseCase.execute(collection, query);

      const selectedClient = clients[0];
      sessionStorage.setItem(storageKey, JSON.stringify(selectedClient));

      this.view.hideClientProgress();
      return selectedClient ? { ...selectedClient } : {};
    } catch (error) {
      console.error(error);
      this.view.hideClientProgress();
      this.view.showError(error);
      return undefined;
    } finally {
      this.view.hideClientProgress();
    }
  }
}

export default ReportsListPagePresenter;
